
import { 
  Card, 
  CardContent, 
  CardHeader, 
  CardTitle 
} from '@/components/ui/card';
import { 
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { FairClickVisit } from '@/types/fairclick';
import { Clock, ExternalLink } from 'lucide-react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

interface VisitHistoryProps {
  visits: FairClickVisit[];
}

export const VisitHistory = ({ visits }: VisitHistoryProps) => {
  if (visits.length === 0) {
    return (
      <Card className="w-full">
        <CardHeader>
          <CardTitle className="text-lg">Historique des visites</CardTitle>
        </CardHeader>
        <CardContent className="py-4 text-center">
          <p className="text-gray-500">
            Vous n'avez pas encore visité de site.
          </p>
        </CardContent>
      </Card>
    );
  }
  
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="text-lg">Historique des visites</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Site</TableHead>
              <TableHead className="text-center">Durée</TableHead>
              <TableHead className="text-center">Statut</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {visits.map(visit => (
              <TableRow key={visit.id}>
                <TableCell className="whitespace-nowrap">
                  {format(new Date(visit.visited_at), 'dd MMM HH:mm', { locale: fr })}
                </TableCell>
                <TableCell>
                  {visit.site ? (
                    <a 
                      href={visit.site.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-blue-500 hover:underline flex items-center gap-1"
                    >
                      {visit.site.title} <ExternalLink size={14} />
                    </a>
                  ) : (
                    <span className="text-gray-500 italic">Site inconnu</span>
                  )}
                </TableCell>
                <TableCell className="text-center whitespace-nowrap">
                  <span className="flex items-center justify-center gap-1">
                    <Clock size={14} />
                    {visit.duration}s
                  </span>
                </TableCell>
                <TableCell className="text-center">
                  {visit.valid ? (
                    <Badge variant="success" className="bg-green-500">Validée</Badge>
                  ) : (
                    <Badge variant="outline" className="border-orange-500 text-orange-500">Non validée</Badge>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
